import { useCallback, useContext, useEffect, useState } from "react";
import { authorOption, robotsOption, statusOption } from "../../../constant";
import { useService } from "../../../hooks";
import { NavigatorContext } from "../../../context";

export const usePage = () => {
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr } = useService("Data", "page");
  const { setTitle } = useService("Meta");
  const { urlToSplitData, getLocationData } = useService("Router");
  const { isEmpty } = useService("Misc");
  const [, setactiveRobotsIndex] = useState<number>(0);
  const [, setactiveStatusIndex] = useState<number>(0);
  const [, setactiveAuthorIndex] = useState<number>(0);
  const [image, setimage] = useState([]);
  const [, setuid] = useState<string>("");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [content, setcontent] = useState("");
  const [, setexcerpt] = useState("");
  const [, setcss] = useState<string>("");
  const [, setjs] = useState<string>("");
  const [, setcanonical] = useState<string>("");
  const [, setrobots] = useState<string>("");
  const [, setmetaDescription] = useState<string>("");
  const [, setmetaKeyword] = useState(null);
  const [, setauthor] = useState<string>("");
  const [, setpublishDate] = useState(new Date());
  const [, setstatus] = useState(null);
  const [, settag] = useState(null);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlSlug = urlData[2];

  const getPageData = useCallback(async (query) => {
    const result = await fetchByAttr(query);
    if (result.status && result.data?.length > 0) {
      if (result.data[0].status !== "publish") {
        navigateTo({ route: "/error404" });
      } else {
        const pageData = result.data[0];
        setactiveAuthorIndex(
          authorOption.findIndex((e) => e.value === pageData.robots)
        );
        setactiveRobotsIndex(
          robotsOption.findIndex((e) => e.value === pageData.robots)
        );
        setactiveStatusIndex(
          statusOption.findIndex((e) => e.value === pageData.status)
        );
        settag(isEmpty(pageData.tag) ? [] : JSON.parse(pageData.tag));
        setmetaKeyword(
          isEmpty(pageData.metaKeyword) ? [] : JSON.parse(pageData.metaKeyword)
        );
        setTitle(pageData.title);
        settitle(pageData.title);
        setslug(pageData.slug);
        setcontent(pageData.content);
        setexcerpt(pageData.excerpt);
        setcss(pageData.css);
        setjs(pageData.js);
        setcanonical(pageData.canonical);
        setrobots(pageData.robots);
        setmetaDescription(pageData.metaDescription);
        setauthor(pageData.author);
        setpublishDate(new Date(pageData.publishDate));
        setstatus(pageData.status);
        setuid(pageData.uid);
        setimage(JSON.parse(pageData.image));
      }
    }
  }, [fetchByAttr, isEmpty, navigateTo, setTitle]);

  useEffect(() => {
    if (slug !== urlSlug) getPageData({ slug: urlSlug });
  }, [slug, urlSlug, getPageData]);
  return {
    title,
    image,
    content,
  };
};
